import { Component } from 'vue-property-decorator';
import './multi-sorting.component.scss';
import { namespace } from 'vuex-class';
import MultiSortingModal from '@/tsort/views/sorting/modal/multi-sorting/multi-sorting-modal.component';
import SwipeButton from '@/common/components/swipe-button/swipe-button';
import FooterComponent from '@/tsort/views/sorting/footer/footer.component';
import AppConstants from '@/common/constants/app.constants';
import LoadingComponent from '@/common/components/loading/loading.component';
import { ScanConfirmPacket } from '@/common/model/scan-confirm-packet.model';
import BaseSortingComponent from '../../base-sorting/base-sorting.component';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { SortModalType } from '@/tsort/enum/sort-modal-type.enum';
import ErrorCdMsgConstants from '@/common/constants/error-cd-msg.constants';
import LogMsgConstants from '@/common/constants/log-msg.constant';
import WarningMessageModal from '@/common/components/warning-message-modal/warning-message-modal.component';
import ErrorMessageUtils from '@/common/utils/error-message.util';
import CommonUtil from '@/common/utils/common.util';
import StringUtils from '@/common/utils/string.util';

const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
const REF_MODAL = 'multiSortingModal';
const FUNCTIONIDTYPE = 1;
@Component({})
export default class MultiSortingComponent extends BaseSortingComponent {
  // ------------------ 抽象メソッド ------------------
  getErrCdInvalidScanCodeFieldName(): string {
    return ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_SCAN_CODE_FIELD_NAME_MULTI_SORT_ERR_CD;
  }
  getErrCdExcessEntry(): string {
    return ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MULTI_SORT_ERR_CD;
  }
  getLogMsgExcessEntry(): string {
    return LogMsgConstants.FUNC_SCAN_CONFIRM_TASK_EXCESS_ENTRY_MULTI_SORT_LOG_MSG;
  }
  getErrMsgOverMaxInput(maxInput: number): string {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_MULTI_SORT_ERR_CD,
      StringUtils.buildMsg([maxInput.toString()], ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_OVER_MAX_INPUT_QUANTITY_ERR_MSG)
    );
  }
  getErrMsgInvalidInputQuantity(): string {
    return ErrorMessageUtils.buildErrorMessage(
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MULTI_SORT_ERR_CD,
      ErrorCdMsgConstants.FUNC_SCAN_CONFIRM_INVALID_INPUT_QUANTITY_MULTI_SORT_ERR_MSG
    );
  }
  getRefModal(callMethod?: boolean): string {
    // 変更された数量の警告メッセージを表示し、サウンドを再生するメソッドです
    if (callMethod) {
      this.showChangedQtyWarningMsgAndPlaySound();
    }
    return REF_MODAL;
  }
  handleCatchError(): void {
    this.scanFailed();
  }
  getWorkInstruction(): number {
    return FUNCTIONIDTYPE;
  }
  // ----------------------抽象メソッドの終わり----------------------
  isShowWarningMsgModal = false;

  /*Sort store*/
  @SortStore.Getter
  multiSortChangedQuantityAlert!: boolean;

  // methods
  async mounted(): Promise<void> {
    (this.$refs.swipeButton as SwipeButton)?.handleError(false);
    this.inputQuantityStore = [];
    this.getScanMode();
  }

  /**
   * 変更された数量メッセージを表示し、警告音を鳴らします。
   */
  showChangedQtyWarningMsgAndPlaySound(): void {
    this.$nextTick(() => {
      if (!this.isShow) {
        return;
      }
      const isChangedQuantity = (this.$refs.multiSortingModal as MultiSortingModal)?.compareInputQtyAndRemainingQty();
      if (isChangedQuantity) {
        this.isShowWarningMsgModal = this.multiSortChangedQuantityAlert;
        setTimeout(() => {
          CommonUtil.playWarningSound();
        }, 270);
      }
    });
  }

  /**
   * 警告メッセージモーダルを非表示にする際の処理。
   */
  onHideWarningMsgModal(): void {
    this.isShowWarningMsgModal = false;
  }

  render() {
    return (
      <main v-frag>
        {/* Scroll Scan Fields */}
        {this.scrollScanFields}
        <b-container fluid class="multi-sorting-page flex-column justify-content-center align-items-center">
          {/* Footer Area */}
          <FooterComponent footerOfPage={AppConstants.FOOTER_MULTI_SORTING} lastChuteNo={this.lastChuteNo}>
            <template slot="swipeButton">
              <SwipeButton on-finished-swipe={() => this.handleModal(SortModalType.SCAN)} ref="swipeButton" text="OK" />
            </template>
          </FooterComponent>
        </b-container>
        {/* Modal */}
        <MultiSortingModal
          ref={REF_MODAL}
          inputQuantityStore={this.inputQuantityStore}
          isShow={this.isShow}
          fieldNameScanCode={this.fieldNameScanCode}
          chuteModeType={this.chuteMode}
          refSortingModal="sortModal2"
          scanCodePattern={this.scanConfirmField.scanCode}
          targetTask={this.targetTaskResponse}
          modeType={this.scanMode}
          on-exitBtn={() => this.exitBtnHandle()}
          on-accept-btn={(scanConfirmPacket: ScanConfirmPacket) => this.acceptBtnHandle(scanConfirmPacket)}
          on-changeTaskList={() => (this.inputQuantityStore = [])}
          isShowWarningMsgModal={this.isShowWarningMsgModal}
        ></MultiSortingModal>
        <WarningMessageModal
          isShow={this.isShowWarningMsgModal}
          warningMsg={ErrorCdMsgConstants.CHANGED_QUANTITY_WARNING_MESSAGE}
          on-hideWarningMsgModal={() => this.onHideWarningMsgModal()}
        />
        <LoadingComponent isActive={this.isLoading} />
      </main>
    );
  }
}
